// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  player: __t.identity(),
  restaurantId: __t.u64().name("restaurant_id"),
  category: __t.string(),
  score: __t.i64(),
  dayNumber: __t.u32().name("day_number"),
  submittedAt: __t.timestamp().name("submitted_at"),
});
